import { Injectable } from '@angular/core';
import { LoDialogService } from 'lo-design-system';
import { map, Observable } from 'rxjs';
import { CancelSubscriptionDialogComponent } from './cancel-subscription-dialog.component';
import {
	CancelSubscriptionDialogData,
	CancelSubscriptionDialogResult
} from './cancel-subscription-dialog.model';

@Injectable({ providedIn: 'root' })
export class CancelSubscriptionDialogService {
	constructor(private dialogs: LoDialogService) {}

	open(
		data: CancelSubscriptionDialogData
	): Observable<CancelSubscriptionDialogResult> {
		return this.dialogs
			.open<
				CancelSubscriptionDialogComponent,
				CancelSubscriptionDialogData,
				CancelSubscriptionDialogResult
			>(CancelSubscriptionDialogComponent, { data })
			.closed.pipe(map(result => result ?? { confirmed: false }));
	}
}
